let nameMap = {
  推广目标: "landing_type",
  应用名称: "app_name",
  创建日期: "create_time",
  预算类型: "budget_mode",
  投放范围: "delivery_range",
  广告位置: "inventory_type",
  投放形式: "union_video_type",
  转化名称: "convert_name",
  账户备注名: "advertiser_name",
  首个视频名称: "vedio_name",
  首个图片名称: "image_name",
  下载方式: "download_type",
  创意分类: "creative_category",
  开始时间: "begin_time",
  创意组名称: "creative_group_name",
  落地页: "external_url",
  投放方式: "flow_control_mode",
  试玩素材: "play_url",
  定向包: "target_tag",
  标题包: "creative_title",
  预算与出价: "budget_bid",
  玩法名称: "play_name",
  素材日期: "material_date",
  组别: "group",
};
let apiMap = {
  landing_type: "推广目标",
  app_name: "应用名称",
  create_time: "创建日期",
  budget_mode: "预算类型",
  delivery_range: "投放范围",
  inventory_type: "广告位置",
  union_video_type: "投放形式",
  convert_name: "转化名称",
  advertiser_name: "账户备注名",
  vedio_name: "首个视频名称",
  image_name: "首个图片名称",
  download_type: "下载方式",
  creative_category: "创意分类",
  begin_time: "开始时间",
  creative_group_name: "创意组名称",
  external_url: "落地页",
  flow_control_mode: "投放方式",
  play_url: "试玩素材",
  target_tag: "定向包",
  creative_title: "标题包",
  budget_bid: "预算与出价",
  play_name: "玩法名称",
  material_date: "素材日期",
  group: "组别",
};

const showDataToApi = (str) => {
  let newStr = str.replace(/{(.*?)}/g, function (node, key) {
    return "{" + (nameMap[key] || key) + "}";
  });
  return newStr;
};

const apiDatatoShow = (str) => {
  let newStr = str.replace(/{(.*?)}/g, function (node, key) {
    return "{" + (apiMap[key] || key) + "}";
  });
  return newStr;
};

export default {
  showDataToApi,
  apiDatatoShow,
};
